import { defineStore } from 'pinia';

export const useUserSidebar = defineStore('userSidebar', {
    state: () => ({
        isSidebarOpen: false
    }),
    actions: {
        toggleSidebar() {
            this.isSidebarOpen = !this.isSidebarOpen;
        },
        closeSidebar() {
            this.isSidebarOpen = false;
        }
    }
});